export const enrollmentViewSx = {
  section: { '& >div:nth-of-type(2n)': { backgroundColor: 'grey.100' }, marginTop: '12px' },
  subtitle: { fontWeight: 'bold', fontSize: '1.55em' },
  thirdLevelTitle: { fontWeight: 'bold', fontSize: '1.25em' }
};
